import React from "react";
import ReactDOM from "react-dom/client";
import "@user27828/shared-utils/client/init";
import _ from "lodash";
import { log } from "@user27828/shared-utils/utils";
import { initializeSession, isDev } from "@smfa/utils/src";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "../src/assets/css/style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import ErrorBoundary from "./components/common/ErrorBoundary";

/* eslint-disable no-undef */
globalThis.log = log; // Make log utility available globally
if (isDev()) {
  globalThis._ = _; // Make lodash available globally
}
/* eslint-enable no-undef */

// Initialize global logging with custom options
log.setOptions({
  type: "client",
  client: {
    namespace: "SMFA-Admin",
    production: ["warn", "error"], // Log types to show in production
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate
      loading={<div>Loading...</div>}
      persistor={persistor}
      onBeforeLift={() => initializeSession({ dispatch: store.dispatch })}
    >
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </PersistGate>
  </Provider>,
);

reportWebVitals();
